module.exports = __webpack_public_path__ + "static/img/2.a09065a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/2.png
// module id = Hch6
// module chunks = 0